import { features } from '@/mocks/data';

export default function FeaturesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            核心功能
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择黄瓜视频？
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            六大核心优势，为你带来全新的短视频体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 md:p-7 bg-background-50 border border-background-200/70 rounded-xl hover:border-accent-300/60 transition-all duration-300"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feature.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}